import Luminary from '@lumen5/luminary';

if (Luminary) {
    // Configure Luminary globally here
}
